exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2TJ556DQ9VXJ26CIGeVkfO{background-color:#000;color:#fff}._33eTs0rMSzJNWmM8gm-LMe{font-size:18px}", ""]);

// exports
exports.locals = {
	"baseStyle": "_2TJ556DQ9VXJ26CIGeVkfO",
	"someStyle": "_33eTs0rMSzJNWmM8gm-LMe _2TJ556DQ9VXJ26CIGeVkfO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/electrode-electrify-react-component-19.css
// module id = 132
// module chunks = 0